/* eslint-disable camelcase */

import type * as interfaces from '@/sections/address/components/AddressForm/Autocomplete/interfaces';

export const SET_VALUE_OPTIONS = {
  shouldValidate: true,
  shouldDirty: true
};

export const DEFAULT_PLACE_RESULT: interfaces.PlacesAutocompleteResult = {
  street_number: '',
  route: '',
  postal_town: '',
  locality: '',
  administrative_area_level_1: '',
  administrative_area_level_2: '',
  administrative_area_level_3: '',
  country_short_name: '',
  country_long_name: '',
  postal_code: '',
  region_id: '',
  comuna_id: '',
  address_formatted: '',
  latitude: undefined,
  longitude: undefined,
  stateNameCustom: '',
  plus_code: ''
};

export const AUTOCOMPLETE_OPTIONS = {
  fields: ['address_components', 'geometry', 'formatted_address', 'plus_code'],
  types: ['geocode'],
  componentRestrictions: { country: 'CL' }
};

export const LABELS = {
  REGIONS_NAME: {
    SHORT_LIBERATOR: 'Libertador',
    LONG_LIBERATOR: 'Libertador General Bernardo O’Higgins',
    OHIGGINS: 'O’Higgins',
    METROPOLITAN: 'Metropolitana',
    EMPTY_STRING: ''
  }
};
